<template>
  <transition name="modal">
    <div class="modal-mask" @click="closeModal($event)">
      <div class="modal-wrapper" id="wrapper">
        <div class="modal-container">
          <transition name="expand">
            <div v-if="isLoading" class="App-confirm__event-card--loading">
              <h4>Loading...</h4>
              <p
                class="mdl-spinner mdl-js-spinner mdl-spinner--single-color is-active"
              />
            </div>
          </transition>

          <div
            v-if="isSimpleRsvp || isVotingDisabled"
            class="mdl-dialog__content center"
          >
            <i class="material-icons big-icon">how_to_reg</i>

            <h1 class="headline">Thank you, your RSVP has been recorded.</h1>

            <div>
              <button
                @click="$emit('close-modal')"
                class="mdl-button mdl-js-button mdl-button--raised"
              >
                <i class="material-icons">close</i>
                Close
              </button>
            </div>
          </div>

          <div v-else class="mdl-dialog__content center">
            <i class="material-icons big-icon">how_to_reg</i>

            <h1 class="headline">Thank you, your RSVP has been recorded.</h1>

            <!-- If meeting is closed or submission deadline expired, do not proceed to next step -->
            <div v-if="isExpired">
              <button
                class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored"
                @click="emitClose"
              >
                Close
              </button>
            </div>
            <div v-else>
              <p>
                But just in case, we recommend voting online anyways.
                <b>It only takes a minute.</b>
              </p>
              <button-component
                color="primary"
                value="Vote Now"
                log-action="start-proxy"
                @click="closeModal('vote')"
              >
                <span slot="icon"><i class="material-icons">send</i></span>
              </button-component>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import _ from 'lodash';
import ButtonComponent from '../Button.vue';

export default {
  name: 'RsvpModal',
  props: {
    homeDisplayOptions: {
      type: Object,
      default() {
        return {};
      }
    },
    isVotingDisabled: {
      type: Boolean,
      default() {
        return false;
      }
    },
    meeting: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  components: {
    ButtonComponent
  },
  computed: {
    isLoading() {
      return this.status === 0;
    },
    isSimpleRsvp() {
      return _.get(this.homeDisplayOptions, 'simple_rsvp', false);
    },
    isExpired() {
      return _.get(this.meeting, 'isExpired', false);
    }
  },
  methods: {
    // close modal if background is clicked
    closeModal(event) {
      if (event.target.id === 'wrapper') {
        this.$emit('close-modal');
      }
    },
    emitClose() {
      this.$emit('close-modal');
    }
  },
  mounted() {
    componentHandler.upgradeAllRegistered();
  }
};
</script>

<style scoped>
.big-icon {
  font-size: 102px;
}

@media only screen and (max-width: 450px) {
  .big-icon {
    font-size: 42px;
  }
}

.close-button-container {
  margin-top: 10px;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-container {
  overflow-y: scroll;
  overflow-x: hidden;

  width: 80vw;
  max-height: 100vw;
  margin: 0px auto;
  padding: 3%;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.modal-header {
  margin-top: 0;
  color: #42b983;
}
.modal-body {
  margin: 20px 0;
}
.modal-default-button {
  float: right;
}
.float-right {
  float: right;
}

/*
* the following styles are auto-applied to elements with
* v-transition="modal" when their visiblity is toggled
* by Vue.js.
*
* You can easily play with the modal transition by editing
* these styles.
*/

.modal-enter,
.modal-leave {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.center {
  text-align: center;
}
</style>
